import { v4 as uuidv4 } from "uuid";

const ANON_COOKIE_NAME = "anon_id";

const getCookie = (name: string): string | null => {
	const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
	return match ? decodeURIComponent(match[2]) : null;
};

export const setAnonId = (invitationId: string, newAnonId: string) => {
	const cookieKey = ANON_COOKIE_NAME + "_" + invitationId;
	// const current = getCookie(cookieKey);
	//
	// if (!current) return false;

	document.cookie = `${cookieKey}=${newAnonId}; path=/; max-age=${60 * 60 * 24 * 365}; SameSite=Lax`;

	return true;
};

export const getOrCreateAnonId = (invitationId: string): string => {
	const cookieKey = ANON_COOKIE_NAME + "_" + invitationId;
	let anonId = getCookie(cookieKey); // Read cookie
	if (!anonId) {
		anonId = uuidv4();
		document.cookie = `${cookieKey}=${anonId}; path=/; max-age=${60 * 60 * 24 * 365}; SameSite=Lax`;
	}
	return anonId;
};

export const deleteAnonId = (invitationId: string) => {
	const cookieKey = ANON_COOKIE_NAME + "_" + invitationId;

	// This will cover most browsers
	document.cookie = `${cookieKey}=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT; SameSite=Lax`;

	// Optional: Also clear without SameSite for broader coverage
	document.cookie = `${cookieKey}=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT`;
};
